import { extendTheme, defineStyleConfig,  createMultiStyleConfigHelpers} from "@chakra-ui/react";
import { cardAnatomy } from "@chakra-ui/anatomy";
import '@fontsource/inter/200.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/montserrat/200.css'
import '@fontsource/montserrat/300.css'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'

const cardHelpers = createMultiStyleConfigHelpers(cardAnatomy.keys)



const variants = {
    project: cardHelpers.definePartsStyle({
        container: {
            my: "0.25rem",
            px: ".5rem",
            py: ".5rem",
            borderRadius: "20px",
            border:"solid 0.5px var(--chakra-colors-container_outline)",
            color: "body_text",
            boxShadow: "0px 0px 4px 0px var(--chakra-colors-container_shadow)",
            width: "100%",
            transition: "0.25s",
            bg: "container_bg",
            _hover: {
                boxShadow: "0px 0px 3px 6px #00000025"
            }
        },
        header: {
            textAlign: "left"
        },
        body: {
            pt: "0.1rem",
            textAlign: "left"
        }
    })
}
const Card = cardHelpers.defineMultiStyleConfig({variants})

const Text = defineStyleConfig({
    baseStyle: {
        fontFamily: 'Inter',
        fontWeight: 'regular'
    },
    variants: {
        base: {},
        body: {
            fontSize: "18px",
            color: "body_text",
            fontWeight: "light",
        },
        tag: {
            fontSize: "18px",
            fontWeight: "medium",
            px: "1rem",
            py: ".5rem",
            borderRadius: "10px",
            border:"solid 0.5px #63636340",
            color: "body_text",
            boxShadow: "0px 0px 4px 0px #00000025",
            width: "fit-content",
            transition: "0.25s",
            bg: "container_bg",
            _hover: {
                boxShadow: "0px 0px 4px 2px #00000025"
            }

        }
    },
    defaultProps: {
        variant: "base",
    }
})

const Heading = defineStyleConfig({
    baseStyle: {
        fontFamily: `Montserrat`,
        fontWeight: 'bold',
        letterSpacing: '0.15em',
    },

    variants: {
        base: {},
        special: {
            fontSize: "32px",
        },
        subheading: {
            fontFamily: `Inter`,
            letterSpacing: 'auto',
            fontSize: "24px",
            color: "heading_text"
        },
    },
    defaultProps: {
        variant: "base",
    }
})
const Button = defineStyleConfig({
    baseStyle: {
        fontFamily: `Montserrat`,
        fontWeight: 'bold',
        letterSpacing: '0.15em',
    },

    sizes: {
        md: {
            px: "3rem",
            py: "3rem",
            fontSize: "24px"
        }
    },
    variants: {
        base: {
            px:"0rem",
            py:"0rem",
            justifyContent: "flex-start"
        },
        special: {
            size: "md",
            color: "accent",
            border: '6px solid transparent',
            borderRadius: "35px",
            bg: 'linear-gradient(var(--chakra-colors-web_bg), var(--chakra-colors-web_bg)) padding-box, linear-gradient(#FF9820 0%, #FFCA62 100%) border-box',
            boxShadow: "0px 0px 3px 2px #FFCA62",
            _hover: {
                boxShadow: "0px 0px 3px 5px #FFCA62"
            }
        },
        iconbutton: {
            justifyContent: "center",
            _hover: {
                boxShadow: "0px 0px 4px 2px #00000025"
            },
            color:"#FF9840", 
            border:"1px solid #63636340"

        },

        moreinfo: {
            fontSize: "20px",
            color: "#D9D9D9",
            borderRadius: "10px",
            bg: "#636363",
            transition: "0.25s",
            width:"fit-content",
            px: "2rem",
            py: "2rem",
            _hover: {
                boxShadow: "0px 0px 2px 5px var(--chakra-colors-container_shadow)"
            }
        }
    },
    defaultProps: {
        variant: "base",
    }
})

const theme = extendTheme({
    components: {
        Button, Heading, Text, Card
    },
    styles: {
        // global: {
        //     "*": {
        //         transitionProperty: "color, background-color, border-color",
        //         transitionDuration: "2000ms",
        //         transitionTimingFunction: "ease"

        // }}

    },
    semanticTokens: {
        colors: {
            web_bg: {
                default: "#FFFFFF",
                _dark: "#252525"

            },
            container_bg: {
                default: "#FFFFFF",
                _dark: "#2D2D2D"
            },
            container_bg_alt: {
                default: "#D9D9D930",
                _dark: "#252525"
            }, 
            container_outline: {
                default: "#63636340",
                _dark: "#D9D9D925"
            },
            container_shadow: {
                default: "#D9D9D9",
                _dark: "#252525"
            },
            heading_text: {
                default: "#000000",
                _dark: "#FFFFFF"
            },
            body_text: {
                default: "#636363",
                _dark: "#D9D9D9"
            },
            body_text_alt: {
                default: "#63636350",
                _dark: "#D9D9D950"

            },
            heading_alt: {
                default: "#2D3748",
                _dark: "#CBD5E0"
            },
            background: {
                default: "#EDEDED",
                _dark: "#373737"
            },
            accent: "#FF9820"
        }
    },

})

export default theme